module.exports = __webpack_public_path__ + "img/left-lightning2.59bd6bd0.png";